import React, { useEffect, useContext, useState, useMemo, useRef, useCallback } from 'react';
import { AppContext } from '../../../RoutesWithAuth';
import { UserPreferencesContext } from '../../common/UserPreferences';
import { useRolePermissions, HOME_PERMISSIONS, NO_ACCESS_TOOLTIP } from '../../common/RolePermissions';
import moment from 'moment';
import Papa from 'papaparse';
import { withNavbar } from './Navbar';
import { withRouterProps } from '../../common/withRouterProps';
import CustomGrid from './customgrid';
import FloatingMessage from '../../common/FloatingMessage';
import { getFormatedDate, v2UIRoutePath } from '../../common/commons';
import axios from '../../common/AxiosConfig';
import RequestsCount from './RequestsCount';
import { LoadingIndicator } from './reports/reconcilationreport/MuiStyled';
import { getHomePageColumns, getAdvancedSearchFields } from './home/constant';
import { useStyles } from './home/styles';

const HomePATH = '';
const HOME_GRID_STATE_KEY = 'homeGridState';

const getSavedNavState = () => {
    try {
        const raw = sessionStorage.getItem(HOME_GRID_STATE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        return null;
    }
};

function Requests(props) {
    const { routerProps } = props
    const classes = useStyles();
    const { history, match, location } = routerProps;
    const routeState = location?.state;
    const savedNavState = useRef(getSavedNavState());
    const hasSyncedFiltersOnce = useRef(false);

    const context = useContext(AppContext)
    const { getPreferences, savePreferences, loaded: prefsLoaded } = useContext(UserPreferencesContext);
    const { hasPermission } = useRolePermissions();

    const authToken = context.authToken.get
    const apps = context.apps.get

    const { page } = match?.params;
    const paramsPageNum = parseInt(page ? page : 1);

    const [currentPage, setCurrentPage] = useState(savedNavState.current?.currentPage || paramsPageNum);
    const [requests, setRequests] = useState([]);
    const [totalResults, setTotalResults] = useState(null);
    const [pageCount, setPageCount] = useState(20);
    const [displayErrMsg, setDisplayErrMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSavingPreferences, setIsSavingPreferences] = useState(false);
    const [defaultHiddenColumns, setDefaultHiddenColumns] = useState({});
    const [activeFilters, setActiveFilters] = useState({});
    const [activeRequestId , setActiveRequestId] = useState(savedNavState.current?.activeRequestId);
    const [activeSortModel, setActiveSortModel] = useState([]);
    const [advancedSearchValues, setAdvancedSearchValues] = useState({});
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(routeState?.showAdvSearch || false);
    const [searchTrigger, setSearchTrigger] = useState(0);

    // Load saved preferences from API on mount — single source of truth for filters/sort/pageCount
    useEffect(() => {
        if (!prefsLoaded) return;
        const prefs = getPreferences('HOME');
        if (prefs.hiddenColumns && Object.keys(prefs.hiddenColumns).length > 0) setDefaultHiddenColumns(prefs.hiddenColumns);
        if (prefs.pageCount) setPageCount(prefs.pageCount);
        if (prefs.sort && prefs.sort.field) setActiveSortModel([prefs.sort]);
        if (prefs.filters && Object.keys(prefs.filters).length > 0) {
            const restoredValues = {};
            Object.keys(prefs.filters).forEach(key => {
                const filter = prefs.filters[key];
                if (filter && filter.value !== undefined) {
                    restoredValues[key] = filter.value;
                }
            });
            setAdvancedSearchValues(restoredValues);
        }
        setSearchTrigger(prev => prev + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prefsLoaded]);

    useEffect(()=>{
        setCurrentPage(paramsPageNum);
    },[paramsPageNum]);

    const COLUMNS = useMemo(()=>{
        return getHomePageColumns(apps, {});
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[apps])

    const ADVANCED_SEARCH_FIELDS = useMemo(()=>{
        return getAdvancedSearchFields(apps);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[apps])

    // Reloading Grid to page 1 when filters change, but skip initial hydration
    useEffect(() => {
        if (!hasSyncedFiltersOnce.current) {
            hasSyncedFiltersOnce.current = true;
            return;
        }
        const filterKeys = Object.keys(activeFilters)
        if (filterKeys.length > 0) {
            history.replace(`${HomePATH}/page/1`)
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[activeFilters])

    useEffect(() => {
        if (routeState) {
            // Restore Home grid state when navigated back from request details via breadcrumb.
            const hasHomeState = routeState.hasOwnProperty('advancedSearchValues');
            if (hasHomeState) {
                setPageCount(routeState.pageCount || 20);
                setActiveSortModel(JSON.parse(JSON.stringify(routeState.activeSortModel || [])));
                setAdvancedSearchValues(routeState.advancedSearchValues || {});
                setCurrentPage(routeState.currentPage || 1 );
                setActiveRequestId(routeState.requestId);
                setShowAdvancedSearch(routeState.showAdvSearch || false);
                setSearchTrigger((prev) => prev + 1);
            }
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
},[routeState?.fromBreadCrumb])

    const getVins = (consumerProfileData, dsrForm) => {
        const vins = []
        if(consumerProfileData){
        for (const profileData of consumerProfileData) {
            if (profileData.vehicleInfo) {
                for (const vehicleInfo of profileData.vehicleInfo) {
                    if (vehicleInfo.vin) {
                        vins.push(vehicleInfo.vin)
                    }
                }
            }
        }
    }
        if(dsrForm.subjectVehicle){
            for (const profileData of dsrForm.subjectVehicle) {
                if (profileData.subjectVIN) {
                    vins.push(profileData.subjectVIN)
                }
            }
        }
        if(dsrForm.subjectVIN){
            vins.push(dsrForm.subjectVIN)
        }
        return vins
    }

    const getAzureGUID = (consumerProfileData) => {
        let guids = []
        for (const profileData of consumerProfileData) {
            if (profileData.linkedIds) {
                for (const vehicleInfo of profileData.linkedIds) {
                    if (vehicleInfo.azureUserIds) {
                        guids =[...guids, ...vehicleInfo.azureUserIds]
                    }
                }
            }
        }
        return guids
    }

    const getCustomerIds = (consumerProfileData) => {
        const customerID = [];
        for (const profileData of consumerProfileData) {
            if (profileData.consumerProfileMetadata) {
                customerID.push(profileData.consumerProfileMetadata.customerId || '--');
            }
        }
        return customerID
    }
    const mapAppDisplayToId = (displayValue) => {
        return apps?.find(({ display }) => display === displayValue)?.id;
    };
    
    const mapAppDisplaysToIds = (values) => {
        return values
            .map(mapAppDisplayToId)
            .filter(Boolean);
    };
    const createBlobAndDownload = (csv) => {
        const downloadLink = document.createElement("a");
        const blob = new Blob(["\ufeff", csv])
        const url = URL.createObjectURL(blob)
        downloadLink.href = url
        const timestamp = moment().format("YYYYMMDDHHmmss")
        downloadLink.download = `Search_Results_${timestamp}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }
    const getSortPayload = () => {
        let payload = {
            sort_order : "DESC",
            sort_column : "CREATED_DATE"
        }
        if(activeSortModel && activeSortModel?.length > 0){
            payload = {
                sort_order : activeSortModel[0].sort?.toUpperCase(),
                sort_column : activeSortModel[0].field?.toUpperCase()
            }
        }
        return payload;
    }
    /**
    * Method returns the params data which are built based on the active Filters on Grid.
    * @returns Object which contains all the active filters 
    */
    const getFilterPayload = () => {
        let payload = {};

        const filterKeys = Object.keys(activeFilters)
        filterKeys.forEach((activeFilter) => {
            if (activeFilters[activeFilter] !== false) {
                let activeFilterName = activeFilter;
                // Formating the Payload based on the active filter applied in the UI
                let paramValue = activeFilters[activeFilter].value
                if (activeFilter === "downstreamApps") {
                    activeFilterName = "app";
                    paramValue = apps?.find(({ display }) => display === paramValue)?.id
                } else if (activeFilterName === "requestId") {
                    activeFilterName = "id";
                }
                payload[activeFilterName] = paramValue
            }
        })
        return {
            ...payload
        }
    }

    /**
    * Method returns the params data built from advanced search values.
    * @returns Object which contains all the advanced search filters 
    */
    const getAdvancedSearchPayload = () => {
        let payload = {};
        
        Object.keys(advancedSearchValues).forEach((key) => {
            const value = advancedSearchValues[key];
            if (value && value !== '' && !(Array.isArray(value) && (value.length === 0 || (value.length === 1 && value[0] === 'All')))) {
                // Handle multi-select "All" option - skip if only "All" is selected
                if (Array.isArray(value) && !value.includes('All')) {
                    if (key === 'app') {
                        const appIds = mapAppDisplaysToIds(value.filter((entry) => entry !== 'All'));
                        if (appIds.length > 0) {
                            payload[key] = appIds.join(', ');
                        }
                    } else {
                        payload[key] = value.join(', ');
                    }
                } else if (!Array.isArray(value)) {
                    // Handle app field mapping
                    if (key === 'app') {
                        const appId = apps?.find(({ display }) => display === value)?.id;
                        if (appId) payload[key] = appId;
                    } else {
                        payload[key] = value;
                    }
                }
            }
        });
        
        return payload;
    }

    const handleAdvancedSearchApply = (formData) => {
        setAdvancedSearchValues(formData);
        setCurrentPage(1);
        history.replace(`${HomePATH}/page/1`);
        setSearchTrigger((prev) => prev + 1);
    }

    useEffect(() => {
        const navState = {
            currentPage,
            activeRequestId
        };
        try {
            sessionStorage.setItem(HOME_GRID_STATE_KEY, JSON.stringify(navState));
        } catch (err) {
            // Ignore storage failures
        }
    }, [currentPage, activeRequestId]);

    const handleSaveDefaults = useCallback((gridState) => {
        setIsSavingPreferences(true);
        const startTime = Date.now();

        // Build filters from advancedSearchValues (Home uses external advanced search,
        // so the grid's internal filters state is empty)
        const savedFilters = {};
        Object.keys(advancedSearchValues).forEach(key => {
            const value = advancedSearchValues[key];
            if (!value || value === '' || (Array.isArray(value) && (value.length === 0 || (value.length === 1 && value[0] === 'All')))) return;
            if (Array.isArray(value)) {
                const filtered = value.filter(v => v !== 'All');
                if (filtered.length > 0) {
                    savedFilters[key] = { value: filtered, operatorValue: 'is' };
                }
            } else {
                savedFilters[key] = { value, operatorValue: 'is' };
            }
        });

        return savePreferences('HOME', {
            filters: savedFilters,
            sort: gridState.sortModel?.[0] || {},
            hiddenColumns: gridState.hiddenColumns,
            pageCount: gridState.pageCount
        }).then(() => {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, 2000 - elapsedTime);
            setTimeout(() => {
                setIsSavingPreferences(false);
                setSuccessMsg('Filter preferences saved successfully');
            }, remainingTime);
        }).catch(() => {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, 2000 - elapsedTime);
            setTimeout(() => {
                setIsSavingPreferences(false);
                setDisplayErrMsg('Failed to save filter preferences');
            }, remainingTime);
        });
    }, [savePreferences, advancedSearchValues]);

    const searchRequests = (e, download_csv = false) => {
        setIsLoading(true);
        axios.get(`ticket/search`, {
            headers: {
                Authorization: authToken
            },
            params: {
                ...getFilterPayload(),
                ...getAdvancedSearchPayload(),
                ...getSortPayload(),
                download_csv: download_csv,
                page: currentPage - 1,
                request_count: pageCount
            }
        }).then(res => {
            setIsLoading(false);
            if (res.status === 204) {
                console.log('No search records found')
                if(!download_csv)
                    setRequests([])
                
                setDisplayErrMsg("No search records found")
            } else if (download_csv) {
                if (res.data.email_sent === "1") {
                    setSuccessMsg(res.data.message)

                } else if (res.data.includes("/ADVANCED_DOWNLOAD/")) {
                    const link = document.createElement('a');
                    link.href = res.data;
                    document.body.appendChild(link);
                    link.click();
                    link.remove()
                }
                else {
                    // Don't update the state if download_csv is set to true
                    // Download the csv file
                    const csv = Papa.unparse(res.data)
                    createBlobAndDownload(csv)
                }
            } else {
                if (res.data[0]) {
                    setTotalResults(res.data[0].total_results)
                    setRequests(res.data)
                } else {
                    setRequests([])
                    setTotalResults(0)
                }

            }

        }).catch(err => {
            setIsLoading(false);
        })
    }

    // Effect to trigger search on mount and whenever searchTrigger increments
    useEffect(() => {
        if (authToken !== null && searchTrigger > 0) {
            searchRequests(null);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTrigger, authToken]);

    const handleResetAllFilters = () => {
        setActiveFilters({});
        setAdvancedSearchValues({});
        setActiveSortModel([]);
        setCurrentPage(1);
        setShowAdvancedSearch(false);
        history.replace(`${HomePATH}/page/1`);
        sessionStorage.removeItem(HOME_GRID_STATE_KEY);
        setActiveRequestId(undefined);
        setSearchTrigger((prev) => prev + 1);
    }

    const handleClose = () => {
        setDisplayErrMsg("");
        setSuccessMsg("");
    }
    const sortDownStreamApps = (sortableList) => {
        const sortedDownStreams = sortableList.split(",").sort(function (a, b) {
            const x = a.trim().toLowerCase();
            const y = b.trim().toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        });
        return sortedDownStreams.join(',');
    }
    return (
        <div className={`${classes.homePageWrapper}`}>
            {(isLoading || isSavingPreferences) && (<LoadingIndicator />)}
            <FloatingMessage
                open={!!displayErrMsg}
                message={displayErrMsg}
                severity="error"
                onClose={handleClose}
            />
            <FloatingMessage
                open={!!successMsg}
                message={successMsg}
                severity="success"
                onClose={handleClose}
            />

            <CustomGrid
                title="Privacy Requests"
                enableCustomFiltering={true}
                columns={COLUMNS}
                defaultFilters={activeFilters}
                defaultSortModel={activeSortModel}
                remoteFiltering={true}
                showDownloadButton={true}
                downloadDisabled={!hasPermission(HOME_PERMISSIONS.DOWNLOAD_CSV)}
                downloadDisabledTooltip={NO_ACCESS_TOOLTIP}
                onDownload={() => searchRequests(null, true)}
                showPagination={true}
                showColumnSelector={true}
                currentPage={currentPage}
                pageCount={pageCount}
                totalResults={totalResults || 0}
                advancedSearchFields={ADVANCED_SEARCH_FIELDS}
                showAdvancedSearch={showAdvancedSearch}
                defaultAdvancedSearchValues={advancedSearchValues}
                onAdvancedSearchApply={handleAdvancedSearchApply}
                onResetAllFilters={handleResetAllFilters}
                onPageChange={(page) => {
                    if (page !== currentPage) {
                        setCurrentPage(page);
                        history.push(`${HomePATH}/page/${page}`)
                        setSearchTrigger((prev) => prev + 1);
                    }
                }}
                onPageCountChange={(count) => {
                    if (count !== pageCount) {
                        setPageCount(count);
                        setCurrentPage(1);
                        history.replace(`${HomePATH}/page/1`)
                        setSearchTrigger((prev) => prev + 1);
                    }
                }}
                applyRemoteSorting={(sortModel)=>{
                    if (JSON.stringify(sortModel) !== JSON.stringify(activeSortModel)) {
                        setCurrentPage(1);
                        setActiveSortModel(sortModel);
                        setSearchTrigger((prev) => prev + 1);
                    }
                }}
                applyRemoteFiltering={(filters) => {
                    if (JSON.stringify(filters) !== JSON.stringify(activeFilters)) {
                        setCurrentPage(1);
                        setActiveFilters(filters);
                        setSearchTrigger((prev) => prev + 1);
                    }
                }}
                onCellClick={(cellparams) => {
                    setActiveRequestId(cellparams.row.requestId);
                    // Persist navigation state synchronously before navigation.
                    try {
                        const navState = {
                            currentPage,
                            activeRequestId: cellparams.row.requestId
                        };
                        sessionStorage.setItem(HOME_GRID_STATE_KEY, JSON.stringify(navState));
                    } catch (err) {
                        // Ignore storage failures
                    }
                    history.push(v2UIRoutePath + "requestdetails/" + cellparams.row.requestId,{
                        currentPage : currentPage,
                        pageCount : pageCount,
                        activeSortModel:activeSortModel,
                        advancedSearchValues,
                        showAdvSearch: showAdvancedSearch,
                        requestId : cellparams.row.requestId
                    });
                }}
                getCellClassName={(params) => {
                    if (params?.row?.requestId === activeRequestId) {
                        return 'active-navigation-row';
                    }
                    return "";
                }}
                rows={requests?.map((row, i) => {
                    row['App Name List'] = row['App Name List'] ? sortDownStreamApps(row['App Name List']) : null;
                    return {
                        id: ((currentPage - 1) * pageCount) + (i + 1),
                        requestId: row.dsar_id || '--',
                        requestor: row?.Requestor || '--',
                        ticket_type: row.ticket_type || '--',
                        status: row.status || '--',
                        created_date: row.created_date,
                        createdDateandTimeLocal: getFormatedDate(row.created_date, false) || "--",
                        createdDateandTime: row.created_date ? moment(row.created_date).format("MM-DD-YYYY") : '--',
                        createdDateandTimeUTC: getFormatedDate(row.created_date, true) || "--",
                        downstreamApps: row['App Name List'] ? row['App Name List'].split(',').slice(0, 4).join(',') : '--',
                        'App Name List': row['App Name List'],
                        noOfVins: (row.dsar?.consumerProfileData?.length > 0 || row.dsar.dsarForm?.subjectVehicle?.length > 0 || row.dsar.dsarForm?.subjectVIN?.length > 0) ? getVins(row.dsar.consumerProfileData, row.dsar.dsarForm).length : '--',
                        noOfGUIDS: (row.dsar?.consumerProfileData?.length > 0) ? getAzureGUID(row.dsar.consumerProfileData).length : '--',
                        noOfCustIds: (row.dsar?.consumerProfileData?.length > 0) ? getCustomerIds(row.dsar.consumerProfileData).length : '--',
                        ...row
                    }
                })}
                activeRowId={activeRequestId}
                defaultHiddenColumns={defaultHiddenColumns}
                onSaveDefaults={handleSaveDefaults}
            />

            <div className={classes.requestsCount}>
                <RequestsCount />
            </div>
        </div>
    );
}

export default withNavbar(withRouterProps(React.memo(Requests)), 0);
